import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PageHeader, Button } from '@/components/shared/ui';
import { ROUTES } from '@/lib/constants/routes';
import { clearTossCheckoutPending, readTossCheckoutPending } from '@/lib/tossPendingCheckout';
import { failMedicrewPayment } from '@/services/paymentConfirmApi';

export default function PaymentTossFail(): React.ReactElement {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code') ?? '';
    const message = searchParams.get('message') ?? '';
    const reportedRef = useRef(false);

    useEffect(() => {
        if (reportedRef.current) return;
        reportedRef.current = true;
        const pending = readTossCheckoutPending();
        const orderId = pending?.medicrewOrderId;
        const safeCode = code.trim() || 'UNKNOWN';
        const safeMessage = message ? decodeURIComponent(message) : '';

        void (async () => {
            try {
                if (orderId != null && orderId > 0) {
                    await failMedicrewPayment({
                        orderId,
                        code: safeCode,
                        message: safeMessage,
                    });
                }
            } catch {
                /* 실패 처리 API 오류는 화면 문구로만 안내 */
            } finally {
                clearTossCheckoutPending();
            }
        })();
    }, [code, message]);

    return (
        <div className="max-w-lg mx-auto px-4 py-16 text-center">
            <PageHeader title="결제 실패" />
            <p className="mt-6 text-gray-700">
                결제가 완료되지 않았습니다. 다른 결제 수단으로 다시 시도하거나 잠시 후 재시도해 주세요.
            </p>
            {(code || message) && (
                <p className="mt-4 text-sm text-gray-500 break-words">
                    {code && <span className="block">코드: {code}</span>}
                    {message && <span className="block mt-1">{decodeURIComponent(message)}</span>}
                </p>
            )}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                    variant="primary"
                    onClick={() => {
                        navigate(ROUTES.COMMON.CART);
                    }}
                >
                    장바구니로
                </Button>
            </div>
        </div>
    );
}
